import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  ICreateEntradaHigienizacaoAgendadaBody,
  ICreateEntradaHigienizacaoAgendadaResponse,
  IGetHigienizacaoAgendadaEfetuadaPaginatedParams,
  IGetHigienizacaoAgendadaEfetuadaPaginatedResponse
} from './higienizacaoAgendada.model';

@Injectable({
  providedIn: 'root'
})
export class HigienizacaoAgendadaService {
  constructor(private http: HttpClient) {}

  public CreateEntradaHigienizacaoAgendada(
    body: ICreateEntradaHigienizacaoAgendadaBody,
    guid: string
  ): Observable<ICreateEntradaHigienizacaoAgendadaResponse> {
    const url = `${environment.baseURL}HigienizacaoAgendada/CreateEntradaHigienizacaoAgendada`;
    const headers = new HttpHeaders({
      IdempotencyKey: guid
    });

    return this.http.post<any>(url, body, { headers: headers });
  }

  public GetHigienizacaoAgendadaEfetuadaPaginated(
    params: IGetHigienizacaoAgendadaEfetuadaPaginatedParams
  ): Observable<IGetHigienizacaoAgendadaEfetuadaPaginatedResponse> {
    const url = `${environment.baseURL}HigienizacaoAgendada/GetHigienizacaoAgendadaEfetuadaPaginated`;
    params.PAGE_NUMBER = params.PAGE_NUMBER || 1;

    const invalidParams = ['', null, undefined, NaN, 0];
    const validParams = Object.fromEntries(
      Object.entries(params).filter(
        ([_, value]) => !invalidParams.includes(value)
      )
    );

    return this.http.get<any>(url, { params: validParams });
  }

  public GetReceiptHigienizacaoAgendadaById(
    PK_AGND: number,
    FL_TIPO_DOCU: number
  ): Observable<any> {
    const url = `${environment.baseURL}HigienizacaoAgendada/GetReceiptHigienizacaoAgendadaById`;
    const params = { PK_AGND, FL_TIPO_DOCU };

    return this.http.get<any>(url, { params });
  }
}
